import dayjs from 'dayjs';

export function plural(value, forms) {
  const n = Math.abs(value) % 100;
  const last = n % 10;
  if (n > 10 && n < 20) return forms[2];
  if (last > 1 && last < 5) return forms[1];
  if (last === 1) return forms[0];
  return forms[2];
}

export function count(value, forms) {
  return `${value} ${plural(value, forms)}`;
}

// Monitoring times are wall-clock times of the monitored computers: shown as they are.
export function formatTime(value) {
  if (!value) return '';
  const moment = dayjs(String(value).replace(' ', 'T'));
  return moment.isValid() ? moment.format('DD.MM.YYYY HH:mm') : String(value);
}

// Conversation timestamps are UTC (ISO); shown in the browser time zone.
export function listDate(value) {
  if (!value) return '';
  const moment = dayjs(value);
  if (!moment.isValid()) return '';
  const today = dayjs();
  if (moment.isSame(today, 'day')) return moment.format('HH:mm');
  if (moment.isSame(today.subtract(1, 'day'), 'day')) return 'вчера';
  return moment.isSame(today, 'year') ? moment.format('DD.MM') : moment.format('DD.MM.YY');
}

export function tokens(value) {
  if (value === null || value === undefined) return '—';
  if (value < 1000) return String(value);
  if (value < 10000) return `${(value / 1000).toFixed(1).replace('.', ',')} тыс.`;
  return `${Math.round(value / 1000)} тыс.`;
}

export function duration(ms) {
  if (!ms && ms !== 0) return '';
  const seconds = Math.round(ms / 1000);
  if (seconds < 1) return '< 1 с';
  if (seconds < 60) return `${seconds} с`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest ? `${minutes} мин ${rest} с` : `${minutes} мин`;
}

export function fileSize(bytes) {
  if (!bytes && bytes !== 0) return '';
  if (typeof bytes === 'string') return bytes;
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1).replace('.', ',')} КБ`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} МБ`;
}
